import { ReducerBase } from "common/reducer";
import initialState from "app/initialState";
import { UserLoggedIn, UserLoggedOut, UserLoggingIn, UserLoginFailed, UserPermissionsLoaded, UserInfoUpdated } from "./login.action";
import UserState from "./userState";
import { MerchantAutoOfferUpdated, MerchantAutoPositionUpdated } from "features/merchants/merchants.actions";
import { MerchantPassOnFillUpdated } from "features/merchants/merchants.actions";
import { UserType } from "./loggedInUser";
import activeMerchantService from "features/merchants/activeMerchantService";


export class UserStateReducer extends ReducerBase<UserState> {
    constructor() {
        super();
        this.addHandler(UserLoggingIn.EventName, this.handleLoggingIn);
        this.addHandler(UserLoggedIn.EventName, this.handleLogin);
        this.addHandler(UserLoginFailed.EventName, this.handleLoginFailed);
        this.addHandler(UserLoggedOut.EventName, this.handleLogout);
        this.addHandler(MerchantAutoOfferUpdated.EventName, this.handleMerchantAutoOfferUpdated);
        this.addHandler(MerchantPassOnFillUpdated.EventName, this.handleMerchantPassOnFillUpdated);
        this.addHandler(MerchantAutoPositionUpdated.EventName, this.handleMerchantAutoPositionUpdated);
        this.addHandler(UserInfoUpdated.EventName, this.handleUserInfoUpdated);
    }

    handleLoggingIn(state: UserState = initialState.userState, event: UserLoggingIn): UserState {
        return {
            ...state,
            isLoggingIn: true,
        };
    }

    handleLogin(state: UserState = initialState.userState, event: UserLoggedIn): UserState {

        if (event.user.activeMerchant != null) {
            activeMerchantService.setActiveMerchant(event.user.activeMerchant);
        }
        return {
            ...state,
            isLoggedIn: true,
            accessToken: event.accessToken,
            name: event.user.name,
            internalId: event.user.internalId,
            merchants: event.user.merchants,
            activeMerchant: event.user.activeMerchant,
            isLoggingIn: false,
            type: event.user.type,
            identityType: event.user.identityType,
            userConfiguration: event.user.userConfiguration,
            isCustomer: event.user.type === UserType.Customer,
            accounts: event.user.accounts,
            customerAccounts: event.user.customerAccounts
        };
    }

    handleUserInfoUpdated(state: UserState = initialState.userState, event: UserInfoUpdated): UserState {

        if (event.user.activeMerchant != null) {
            activeMerchantService.setActiveMerchant(event.user.activeMerchant);
        }
        return {
            ...state,
            merchants: event.user.merchants,
            activeMerchant: event.user.activeMerchant,
            type: event.user.type,
            userConfiguration: event.user.userConfiguration,
            isCustomer: event.user.type === UserType.Customer
        };
    }

    handleLoginFailed(state: UserState = initialState.userState, event: UserLoginFailed): UserState {

        return {
            ...state,
            isLoggedIn: false,
            isLoginFailed: true,
            accessToken: null,
            name: null,
            internalId: null,
            merchants: null,
            activeMerchant: null,
            isLoggingIn: false,
            type: null,
            isCustomer: false
        };
    }

    handleLogout(state: UserState = initialState.userState, event: UserLoggedOut): UserState {
        return new UserState();
    }

    handleMerchantAutoOfferUpdated(state: UserState = initialState.userState, event: MerchantAutoOfferUpdated): UserState {
        return {
            ...state,
            activeMerchant: {...state.activeMerchant, enableAutoOffer: event.enabled }
        };
    }

    handleMerchantPassOnFillUpdated(state: UserState = initialState.userState, event: MerchantPassOnFillUpdated): UserState {
        return {
            ...state,
            activeMerchant: {...state.activeMerchant, enablePassOnFill: event.enabled }
        };
    }

    handleMerchantAutoPositionUpdated(state: UserState = initialState.userState, event: MerchantAutoPositionUpdated): UserState {
        return {
            ...state,
            activeMerchant: { ...state.activeMerchant, enableAutoPosition: event.enabled }
        };
    }

    handleDefault(state: UserState = initialState.userState) {
        return state;
    }
}


export class PermissionReducer extends ReducerBase<string[]> {
    constructor() {
        super();
        this.addHandler(UserPermissionsLoaded.EventName, this.handlePermissionsLoaded);
    }

    handlePermissionsLoaded(state = initialState.userPermissions, event: UserPermissionsLoaded): string[] {
        return event.permissions;
    }

    handleDefault(state = initialState.userPermissions) {
        return state;
    }
}

